import React from 'react';
import Barcode from "react-barcode";

const IntoBarcodeLable = (props) => {
  const {
    productName,
    productPrice,
    productCode,
    barcodeLength,
    barcodeWidth,
    displayProductCodeValue,
    productColor,
    productSize,
    productGroupCode,
  } = props

  return (
      <div className="singleBarcodeWidthAndHeight"
        // style={{'justify-content': 'flex-start' , 'padding-left': '1mm'}}
      >
        {/**/}
        {/*<h6> Hello From The Other side</h6>*/}
        {/**/}
        <div className="barcode-spec">
          <div className="product-name">
            <div>{productName}</div>
          </div>
          {productPrice && <div className="product-price">{productPrice}</div>}
          <div className={"position-relative"}>
            <Barcode
              value={productCode === undefined ? "0000" : productCode}
              // height={30}
              height={barcodeLength * 1.4}
              format={"CODE128B"}
              // width={1.3}
              width={barcodeWidth / 30}
              fontSize={10}
              margin={0}
              displayValue={displayProductCodeValue}
            />
            {!displayProductCodeValue && <div style={{
              fontSize: 9,
              fontWeight:"bold",

            }}>{productGroupCode}-{productCode}</div>}
          </div>
        </div>
        {(productColor || productSize) &&
          <div className="barcode-opt">
            {productColor && <div>{productColor}</div>}
            {productSize && <div>{productSize}</div>}
          </div>
        }

        {/*    */}
      </div>
  );
};

export default IntoBarcodeLable;
